import { createAction, createAsyncThunk, nanoid } from '@reduxjs/toolkit'
import { LogsServerData, LogsRequestAttributes } from '@lk/api'
import { translate } from 'loankeeper-common/helpers'
import { loadingActions } from 'loankeeper-common/components/hocs/LazyLoading'

import { actions as LKModalActions } from '../../features/shared/LKModal'
import { ThunkApi } from '../index.d'
import { getLogLookups } from './logs.selectors'

export const resetLogs = createAction('[LOGS] RESET_LOGS', () => ({
  payload: nanoid(),
}))

export const loadLogs = createAsyncThunk<LogsServerData, LogsRequestAttributes, ThunkApi>(
  '[LOGS] LOAD_LOGS',
  async ({ startDate, endDate, app, module, order, tag, level, page }, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.logs.get({ startDate, endDate, app, module, order, tag, level, page })

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(translate(`LKMESSAGE-${result.error.message}`)))

    return rejectWithValue('Failed to load logs')
  },
)

export const loadLogsPage = (requestAttributes: LogsRequestAttributes) => {
  return async (dispatch) => {
    loadingActions.start()

    const result = await dispatch(loadLogs(requestAttributes))

    if (loadLogs.fulfilled.match(result)) {
      if (result.payload.length > 0) {
        await dispatch(loadLogs({ ...requestAttributes, page: requestAttributes.page + 1 }))
      }
    }

    loadingActions.stop()
  }
}

export const loadLogLookups = createAsyncThunk<string[], void, ThunkApi>(
  '[LOGS] LOAD_LOG_LOOKUPS',
  async (_, { getState, extra, rejectWithValue }) => {
    const slice = getLogLookups(getState())

    if (slice.data.length !== 0) {
      return slice.data
    }

    const result = await extra.api.logs.lookups()

    if (result.success) {
      return result.data
    }

    return rejectWithValue('Failed to load log lookups')
  },
)
